/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DomainMappingDto } from './DomainMappingDto';
import {
    DomainMappingDtoFromJSON,
    DomainMappingDtoFromJSONTyped,
    DomainMappingDtoToJSON,
    DomainMappingDtoToJSONTyped,
} from './DomainMappingDto';

/**
 * 
 * @export
 * @interface DomainMappingListResponse
 */
export interface DomainMappingListResponse {
    /**
     * 
     * @type {Array<DomainMappingDto>}
     * @memberof DomainMappingListResponse
     */
    data?: Array<DomainMappingDto>;
    /**
     * 
     * @type {number}
     * @memberof DomainMappingListResponse
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof DomainMappingListResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof DomainMappingListResponse
     */
    pageSize?: number;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof DomainMappingListResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof DomainMappingListResponse
     */
    error?: string;
}

/**
 * Check if a given object implements the DomainMappingListResponse interface.
 */
export function instanceOfDomainMappingListResponse(value: object): value is DomainMappingListResponse {
    return true;
}

export function DomainMappingListResponseFromJSON(json: any): DomainMappingListResponse {
    return DomainMappingListResponseFromJSONTyped(json, false);
}

export function DomainMappingListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DomainMappingListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(DomainMappingDtoFromJSON)),
        'total': json['total'] == null ? undefined : json['total'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function DomainMappingListResponseToJSON(json: any): DomainMappingListResponse {
    return DomainMappingListResponseToJSONTyped(json, false);
}

export function DomainMappingListResponseToJSONTyped(value?: DomainMappingListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(DomainMappingDtoToJSON)),
        'total': value['total'],
        'page': value['page'],
        'pageSize': value['pageSize'],
        'success': value['success'],
        'error': value['error'],
    };
}

